import { Box } from '@mui/material';
import { CardType, useCardConfig } from '../../providers/CardConfigProvider';
import VegaImageSelector from '../common/v2/ImageSelector/VegaImageSelector';
import VegaSelectV2 from '../common/v2/VegaSelectV2';

type Props = {
  cardType: CardType;
};

function CardCobrandLogoSelector({ cardType }: Props) {
  const { physicalCardConfig, virtualCardConfig, onCobrandLogoChange } =
    useCardConfig();

  const getCobrandLogo = () => {
    return cardType == CardType.PHYSICAL
      ? physicalCardConfig.cobrandLogo
      : virtualCardConfig.cobrandLogo;
  };

  return (
    <VegaSelectV2
      placeholder="Upload Co brand Logo"
      renderOptions={() => (
        <VegaImageSelector
          title={'Co-Brand Logo'}
          images={[
            'https://vegapay-alpha-image-assets.s3.ap-south-1.amazonaws.com/card_resources/Group+1658.png',
            'https://vegapay-alpha-image-assets.s3.ap-south-1.amazonaws.com/card_resources/VegaPay.png',
          ]}
          onAddClick={function (): void {}}
          onImageSelect={function (value: string): void {
            onCobrandLogoChange(value, cardType);
          }}
          selectedImage={getCobrandLogo()}
        />
      )}
      hidePlaceholder={Boolean(getCobrandLogo())}
      renderSelectedValue={() => {
        return (
          <Box
            style={{
              height: '20px',
              maxWidth: '80px',
              backgroundColor: '#f1f1f1f1',
              padding: 0,
              margin: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              style={{ objectFit: 'contain' }}
              height={'80%'}
              width={'80%'}
              src={getCobrandLogo()}
            ></img>
          </Box>
        );
      }}
    />
  );
}

export default CardCobrandLogoSelector;
